import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ApiCommunityService } from '@services/api-community.service';
import { SharedService } from '@services/shared.service';
import { CommunityModel } from '@shared/models/CommunityModel';
import { Country } from '@shared/models/Enums';
import { ICountry } from '@shared/models/Interfaces';
import { CommunitySearchModel } from '@shared/models/SearchModel';
import { SessionModel } from '@shared/models/SessionModel';
import { ApiAuthService } from '@services/api-auth.service';

@Component({
    selector: 'app-panama-lobby',
    templateUrl: './panama-lobby.component.html',
    styleUrls: ['./panama-lobby.component.scss']
})

export class PanamaLobbyComponent implements OnInit {

    @Output() onChangeCountry: EventEmitter<Country> = new EventEmitter<Country>();

    //Country
    dropdownOpen = false;

    // Catálogo completo; solo se muestran los habilitados (EnabledCountries del API)
    private static readonly ALL_COUNTRIES: ICountry[] = [
        { id: Country.CR, name: 'Costa Rica', img: 'https://cdn-icons-png.flaticon.com/128/4854/4854928.png' },
        { id: Country.PA, name: 'Panamá', img: 'https://cdn-icons-png.flaticon.com/128/197/197590.png' },
        { id: Country.MX, name: 'México', img: 'https://cdn-icons-png.flaticon.com/128/197/197397.png' },
        { id: Country.CO, name: 'Colombia', img: 'https://cdn-icons-png.flaticon.com/128/197/197575.png' },
        { id: Country.NI, name: 'Nicaragua', img: 'https://cdn-icons-png.flaticon.com/128/197/197623.png' },
        { id: Country.GT, name: 'Guatemala', img: 'https://cdn-icons-png.flaticon.com/128/197/197597.png' }
    ];

    countries: ICountry[] = PanamaLobbyComponent.ALL_COUNTRIES.filter(c => c.id == Country.CR || c.id == Country.PA);

    selectedCountry: ICountry = this.countries[1];

    communities: CommunityModel[] = [];
    firstCommunity: CommunityModel;

    session: SessionModel;

    constructor(public router: Router,
        public sharedService: SharedService,
        private apiCommunityService: ApiCommunityService,
        private apiAuthService: ApiAuthService,
    ) {
    }

    ngOnInit(): void {

        // Solo países habilitados en este ambiente
        this.apiAuthService.getEnabledCountries().then(enabled => {
            this.countries = PanamaLobbyComponent.ALL_COUNTRIES.filter(c => enabled.includes(c.id));
        });

        this.session = this.apiCommunityService.getSession();
        if (this.session && this.session.user) {

            this._getAllCommunities();
        }
    }

    toggleDropdown() {

        this.dropdownOpen = !this.dropdownOpen;
    }

    selectCountry(country: ICountry) {

        if (country.id == Country.CR) {

            this.onChangeCountry.emit(Country.CR);
            return;
        }

        this.selectedCountry = country;
        this.dropdownOpen = false;
    }

    navigateToPage(page) {

        this.router.navigate([page]);
    }

    onDetailsOrJoin(communityId: number) {

        // View community details
        this.router.navigate(['/community-join', communityId]);
    }

    private _getAllCommunities() {

        this.sharedService.setLoading(true);

        let search = new CommunitySearchModel();

        this.apiCommunityService.getAllCommunities(search).then(
            (results) => {

                this.communities = results;
                this.firstCommunity = this.communities[0];

                this.sharedService.setLoading(false);
            },
            (err) => {

                this.sharedService.setLoading(false);

                let errMsg = `Error al cargar información de las comunidades.`;
                
                // Desautorizado navigate to login
                if (err.status == 401 || err.message?.indexOf('caducado') >= 0) {

                    this.sharedService.showErrorAlert(null, 'Error al cargar la información solicitada').then(()=>{
                        this.router.navigate(['/market']);
                    });
                    return;
                }
                this.sharedService.showErrorAlert(null, errMsg);
            }
        );
    }
}
